import agency from '@/api/agency/agency-profile'

import { baseState, baseMutations } from '@/store/mixins'
import { isEmpty } from 'lodash'

export const state = {
  ...baseState,
  isActive: 1,
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_ACTIVE(state, value){
    state.isActive = value
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          is_active: context.state.isActive
        }
      },
      attrubutes
    )
    return agency.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return agency.store(data)
  },
  update(context, { id, data }) {
    return agency.update(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await agency.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  upload(context, data) {
    return agency.imageLogo(data)
  },
  getFormViewData(context, attributes = {}) {
    return agency.formModel(attributes)
  }
}